import React from "react";
import { Modal, Button, theme } from "antd";

function UploadPreviewModal({
    open,
    uploadPreview,
    onClose,
    onUploadOriginal,
    onUploadCompressed,
}) {
    const { colorBgContainer } = theme.useToken();

    if (!uploadPreview) return null;

    return (
        <Modal
            open={open}
            title="Prepare images to upload"
            onCancel={onClose}
            footer={null}
            destroyOnHidden
        >
            <div style={{ display: "flex", gap: 16 }}>
                <img
                    src={URL.createObjectURL(uploadPreview.compressed)}
                    alt="preview"
                    style={{
                        width: 120,
                        height: "auto",
                        borderRadius: 6,
                        background: colorBgContainer,
                    }}
                />
                <div style={{ flex: 1 }}>
                    <p>
                        Original Size:{" "}
                        <b>
                            {(uploadPreview.original.size / 1024).toFixed(2)} KB
                        </b>
                    </p>
                    <p style={{ color: "green" }}>
                        Compressed Size:{" "}
                        <b>
                            {(uploadPreview.compressed.size / 1024).toFixed(2)}{" "}
                            KB
                        </b>
                    </p>
                    <div style={{ marginTop: 16 }}>
                        <Button onClick={onUploadOriginal}>
                            Upload Original
                        </Button>
                        <Button
                            type="primary"
                            style={{ marginLeft: 8 }}
                            onClick={onUploadCompressed}
                        >
                            Upload Compressed
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default UploadPreviewModal;
